<template>
  <div>
    <div class="toolbtn flex" v-if="activeName == 'first'">
      <switchcore></switchcore>
      <el-tooltip class="item" effect="dark" content="刷新" placement="top">
        <div @click="refresh()" class="cursorpointer margin-top10">
          <img
            src="@/assets/barsvg/icon／12sx(1).png"
            style="position: relative; top: 2px"
            alt=""
          />
          <span class="f12 pad-left5" style="color: #969eac">刷新</span>
        </div>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="返回" placement="top">
        <callback></callback>
      </el-tooltip>
    </div>
    <div class="toolbtn flex" v-if="activeName == 'second'">
      <switchcore></switchcore>
      <el-tooltip class="item" effect="dark" content="刷新" placement="top">
        <div @click="refreshs()" class="cursorpointer margin-top10">
          <img
            src="@/assets/barsvg/icon／12sx(1).png"
            style="position: relative; top: 2px"
            alt=""
          />
          <span class="f12 pad-left5" style="color: #969eac">刷新</span>
        </div>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="返回" placement="top">
        <callback></callback>
      </el-tooltip>
    </div>
    <div class="width100 margin-auto border-rd3">
      <el-skeleton
        class="width100 backwhite"
        :loading="true"
        animated
        :throttle="500"
      >
        <template slot="template">
          <el-tabs
            v-model="activeName"
            class="width98 pad-top10 border-rd3 margin-auto"
          >
            <el-tab-pane label="我分享的文件" name="first">
              <!-- 关键词检索  -->
              <div
                class="width100 f14 backwhite border-rd3"
                style="min-height: 72px"
                v-if="serchkey"
              >
                <el-form
                  ref="ruleForm"
                  size="small"
                  label-width="60px"
                  class="demo-ruleForm flexleft"
                >
                  <el-form-item label="关键词">
                    <el-input
                      placeholder="请输入关键词"
                      v-model="inputs"
                    ></el-input>
                  </el-form-item>
                  <div class="margin-left20 margin-top10 margin-bot10">
                    <el-button type="primary" @click="submitForms()"
                      >检 索</el-button
                    >
                    <el-button @click="resetForms()">重 置</el-button>
                  </div>
                </el-form>
              </div>
            </el-tab-pane>
            <el-tab-pane label="我接收的文件" name="second">
              <!-- 关键词检索  -->
              <div
                class="width100 f14 backwhite border-rd3"
                style="min-height: 72px"
                v-if="serchkey"
              >
                <el-form
                  ref="ruleForm"
                  size="small"
                  label-width="60px"
                  class="demo-ruleForm flexleft"
                >
                  <el-form-item label="关键词">
                    <el-input
                      placeholder="请输入关键词"
                      v-model="inputss"
                    ></el-input>
                  </el-form-item>
                  <div class="margin-left20 margin-top10 margin-bot10">
                    <el-button type="primary" @click="submitFormss()"
                      >检 索</el-button
                    >
                    <el-button @click="resetFormss()">重 置</el-button>
                  </div>
                </el-form>
              </div>
            </el-tab-pane>
          </el-tabs>
        </template>
      </el-skeleton>

      <el-skeleton
        v-if="activeName == 'first'"
        class="width100 backwhite border-rd3"
        :loading="loading"
        animated
        :throttle="500"
      >
        <template slot="template">
          <div
            class="
              width98
              backwhite
              pad-top20 pad-bot20
              margin-auto margin-auto margin-top15
              border-rd3
              alldigital
            "
            v-if="total != 0"
          >
            <el-table
              :data="page"
              stripe
              class="width100 eltable margin-auto f14"
            >
              <el-table-column label="文件名" width="380">
                <template slot-scope="scope">
                  <span class="f14 text-ellipsis">
                    {{ scope.row.file_name }}</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                prop="share.realname"
                label="分享对象"
                width="180"
              >
              </el-table-column>
              <el-table-column prop="expire_time" label="到期时间">
              </el-table-column>
              <el-table-column prop="message" label="附言"> </el-table-column>
              <el-table-column prop="address" label="操作" width="180">
                <template slot-scope="scope">
                  <span
                    class="bluecolor cursorpointer"
                    @click="designDetail(scope.row)"
                    >取消分享</span
                  >
                </template>
              </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div
              class="flex-betweennowrap pad-top20 pad-right10"
              v-if="total != 0"
            >
              <span class="bluecolor"></span>
              <el-pagination
                :hide-on-single-page="true"
                @size-change="handleSizeChange"
                @current-change="currentchange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 30, 40, 50]"
                :page-size="per_page"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                background
              >
              </el-pagination>
            </div>
          </div>
          <div
            class="width100 margin-auto backgroudFFF margin-top15"
            v-if="total == 0"
          >
            <el-empty
              :image="require('@/assets/barsvg/zwsj@3x.png')"
              :image-size="200"
              description="抱歉，没有搜到您想要的内容"
              class="heightempty"
              ><p style="position: relative; bottom: 60px" class="f14">
                暂无数据
              </p></el-empty
            >
          </div>
        </template>
      </el-skeleton>
      <el-skeleton
        v-if="activeName == 'second'"
        class="width100 backwhite border-rd3"
        :loading="loading"
        animated
        :throttle="500"
      >
        <template slot="template">
          <div
            class="
              width98
              backwhite
              pad-top20 pad-bot20
              margin-auto margin-auto margin-top15
              border-rd3
              alldigital
            "
            v-if="totals != 0"
          >
            <el-table
              :data="pages"
              stripe
              class="width100 eltable margin-auto f14"
            >
              <el-table-column label="文件名" width="380">
                <template slot-scope="scope">
                  <span class="f14 text-ellipsis">
                    {{ scope.row.file_name }}</span
                  >
                </template>
              </el-table-column>
              <el-table-column prop="share.realname" label="分享人" width="180">
              </el-table-column>
              <el-table-column prop="expire_time" label="到期时间">
              </el-table-column>
              <el-table-column prop="message" label="附言"> </el-table-column>
              <el-table-column prop="address" label="操作" width="180">
                <template slot-scope="scope">
                  <span
                    class="width10 bluecolor"
                    v-if="
                      new Date().getTime() > Date.parse(scope.row.expire_time)
                        ? false
                        : true
                    "
                  >
                    <span
                      @click="designDetails(scope.row)"
                      class="pad-right10 cursorpointer"
                      v-if="scope.row.status == 0 ? true : false"
                      >接收文件</span
                    >
                    <span v-if="scope.row.status == 1 ? true : false"
                      ><span
                        class="pad-right10 cursorpointer"
                        @click="downloadExcel(scope.row)"
                        >下载文件</span
                      >
                      <span
                        @click="dialogVisibleimag(scope.row)"
                        class="cursorpointer"
                        >在线预览</span
                      ></span
                    ></span
                  >
                  <span
                    class="width10"
                    style="color: #969eac"
                    v-if="
                      new Date().getTime() > Date.parse(scope.row.expire_time)
                        ? true
                        : false
                    "
                    >文件已过期</span
                  >
                </template>
              </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div
              class="flex-betweennowrap pad-top20 pad-right10"
              v-if="totals != 0"
            >
              <span class="bluecolor"></span>
              <el-pagination
                :hide-on-single-page="true"
                @size-change="handleSizeChange"
                @current-change="currentchange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 30, 40, 50]"
                :page-size="per_page"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totals"
                background
              >
              </el-pagination>
            </div>
          </div>
          <div
            class="width100 margin-auto backgroudFFF margin-top15"
            v-if="totals == 0"
          >
            <el-empty
              :image="require('@/assets/barsvg/zwsj@3x.png')"
              :image-size="200"
              description="抱歉，没有搜到您想要的内容"
              class="heightempty"
              ><p style="position: relative; bottom: 60px" class="f14">
                暂无数据
              </p></el-empty
            >
          </div>
        </template>
      </el-skeleton>

      <el-dialog
        title=""
        :visible.sync="dialogVisiblenull"
        :close-on-click-modal="false"
        :show-close="true"
        :center="true"
        :modal="true"
        :modal-append-to-body="true"
        :append-to-body="true"
        width="25%"
        class="errorbox"
      >
        <span class="errormessage">{{ errormessage }}</span>
        <span slot="footer" class="dialog-footer">
          <button @click="dialogVisiblenull = false" class="errorbutton">
            确 定
          </button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
  <script>
import callback from "@/components/callback.vue";
import switchcore from "@/components/switchcore.vue";
import {
  filesharemyshare,
  filesharemyreceive,
  filesharedel,
  filesharereceive,
} from "@/api/loader/loder.api";
import BUS from "@/BUS/BUS";
import { Base64 } from "js-base64";
export default {
  data() {
    return {
      loading: true,
      errormessage: "",
      dialogVisiblenull: false,
      thisNum: 1,
      thisNums: 1,
      page: [],
      pages: [],
      total: 0,
      totals: 0,
      per_page: 0,
      per_pages: 0,
      currentPage: 1,
      currentPages: 1,
      centerDialogVisible: false,
      Remind: 0,
      behalf: 0,
      sell: 0,
      date: "",
      serchkey: true,
      inputs: "",
      inputss: "",
      activeName: "first",
      messgehead: true,
      messgeheads: true,
    };
  },
  components: {
    callback,
    switchcore,
  },

  methods: {
    // 第一个分页
    currentchange(val) {
      this.thisNum = val;
      filesharemyshare({
        page: val,
        _keywords: this.inputs,
      }).then((res) => {
        if (res.data.code == 200) {
          this.page = res.data.data.data;
          this.pagination = true;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
          this.page.forEach((i) => {
            i.update_time = i.update_time.slice(0, 10);
          });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    handleSizeChange(val) {
      filesharemyshare({
        page: 1,
        limit: val,
      }).then((res) => {
        if (res.data.code == 200) {
          this.page = res.data.data.data;
          this.pagination = true;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
          this.page.forEach((i) => {
            i.update_time = i.update_time.slice(0, 10);
          });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 第一个分页
    currentchanges(val) {
      this.thisNums = val;
      filesharemyreceive({ page: val, _keywords: this.inputss }).then((res) => {
        if (res.data.code == 200) {
          this.pages = res.data.data.data;
          this.paginations = true;
          this.totals = res.data.data.total;
          this.per_pages = res.data.data.per_page;
          this.pages.forEach((i) => {
            i.update_time = i.update_time.slice(0, 10);
          });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    handleSizeChanges(val) {
      filesharemyreceive({ page: this.thisNums, limit: val }).then((res) => {
        if (res.data.code == 200) {
          this.pages = res.data.data.data;
          this.paginations = true;
          this.totals = res.data.data.total;
          this.per_pages = res.data.data.per_page;
          this.pages.forEach((i) => {
            i.update_time = i.update_time.slice(0, 10);
          });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // input重 置专利
    resetForms() {
      this.inputs = null;
      this.thisNum = 1;
      // 我分享的文件
      filesharemyshare({ page: this.thisNum }).then((res) => {
        if (res.data.code == 200) {
          this.page = res.data.data.data;
          this.pagination = true;
          this.total = res.data.data.total;
          if (res.data.data.total == 0) {
            this.messgehead = false;
          } else {
            this.messgehead = true;
          }
          this.per_page = res.data.data.per_page;
          this.page.forEach((i) => {
            i.update_time = i.update_time.slice(0, 10);
          });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },

    resetFormss() {
      this.inputss = null;
      this.thisNums = 1;
      //接收的文件
      filesharemyreceive({ page: this.thisNums }).then((res) => {
        if (res.data.code == 200) {
          this.pages = res.data.data.data;
          this.paginations = true;
          this.totals = res.data.data.total;
          if (res.data.data.total == 0) {
            this.messgeheads = false;
          } else {
            this.messgeheads = true;
          }
          this.per_pages = res.data.data.per_page;
          this.pages.forEach((i) => {
            i.update_time = i.update_time.slice(0, 10);
          });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },

    submitForms() {
      filesharemyshare({ _keywords: this.inputs, page: 1 }).then((res) => {
        if (res.data.code == 200) {
          this.page = res.data.data.data;
          this.pagination = true;
          this.total = res.data.data.total;
          if (res.data.data.total == 0) {
            this.messgehead = false;
          } else {
            this.messgehead = true;
          }
          this.per_page = res.data.data.per_page;
          this.page.forEach((i) => {
            i.update_time = i.update_time.slice(0, 10);
          });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },

    submitFormss() {
      filesharemyreceive({ _keywords: this.inputss, page: 1 }).then((res) => {
        if (res.data.code == 200) {
          this.pages = res.data.data.data;
          this.paginations = true;
          this.totals = res.data.data.total;
          if (res.data.data.total == 0) {
            this.messgeheads = false;
          } else {
            this.messgeheads = true;
          }
          this.per_pages = res.data.data.per_page;
          this.pages.forEach((i) => {
            i.update_time = i.update_time.slice(0, 10);
          });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },

    // 取消分享

    designDetail(row) {
      this.$confirm("此操作将取消分享, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          filesharedel({ id: row.id }).then((res) => {
            if (res.data.code == 200) {
              this.refresh();
            } else {
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 接收文件
    designDetails(row) {
      filesharereceive({ id: row.id }).then((res) => {
        if (res.data.code == 200) {
          this.activeName = "second";
          this.refreshs();
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 下载文件
    downloadExcel(row) {
      let a = document.createElement("a");
      a.style.display = "none";
      a.download = name;
      a.href = window.g.Apisrc + row.file_url;
      document.body.appendChild(a);
      a.click();
    },
    // 文件预览
    dialogVisibleimag(row) {
      var url = window.g.Apisrc + row.file_url;
      window.open(
        window.g.previewurl + "?url=" + encodeURIComponent(Base64.encode(url))
      );
    },
    refresh() {
      this.$loading.show(); // 显示loading
      // 我分享的文件
      filesharemyshare({ page: this.thisNum, _keywords: this.inputs }).then(
        (res) => {
          if (res.data.code == 200) {
            this.$loading.hide(); // 隐藏loading
            this.page = res.data.data.data;
            this.pagination = true;
            this.total = res.data.data.total;
            if (res.data.data.total == 0) {
              this.messgehead = false;
            } else {
              this.messgehead = true;
            }
            this.per_page = res.data.data.per_page;
            this.page.forEach((i) => {
              i.update_time = i.update_time.slice(0, 10);
            });
          } else {
            this.$loading.hide(); // 隐藏loading
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        }
      );
    },
    refreshs() {
      this.$loading.show(); // 显示loading
      //接收的文件
      filesharemyreceive({ page: this.thisNums, _keywords: this.inputss }).then(
        (res) => {
          if (res.data.code == 200) {
            this.$loading.hide(); // 隐藏loading
            this.pages = res.data.data.data;
            this.paginations = true;
            this.totals = res.data.data.total;
            if (res.data.data.total == 0) {
              this.messgeheads = false;
            } else {
              this.messgeheads = true;
            }
            this.per_pages = res.data.data.per_page;
            this.pages.forEach((i) => {
              i.update_time = i.update_time.slice(0, 10);
            });
          } else {
            this.$loading.hide(); // 隐藏loading
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        }
      );
    },
  },

  created() {
    BUS.$on("serchkey", (data) => {
      this.serchkey = data;
    });

    // 我分享的文件
    filesharemyshare({ page: this.thisNum }).then((res) => {
      if (res.data.code == 200) {
        this.page = res.data.data.data;
        this.pagination = true;
        this.total = res.data.data.total;
        if (res.data.data.total == 0) {
          this.messgehead = false;
        } else {
          this.messgehead = true;
        }
        this.per_page = res.data.data.per_page;
        this.page.forEach((i) => {
          i.update_time = i.update_time.slice(0, 10);
        });
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
    //接收的文件
    filesharemyreceive({ page: this.thisNums }).then((res) => {
      if (res.data.code == 200) {
        this.pages = res.data.data.data;
        this.paginations = true;
        this.totals = res.data.data.total;
        if (res.data.data.total == 0) {
          this.messgeheads = false;
        } else {
          this.messgeheads = true;
        }
        this.per_pages = res.data.data.per_page;
        this.pages.forEach((i) => {
          i.update_time = i.update_time.slice(0, 10);
        });
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
};
</script>
  <style scoped>
.eltable >>> .el-table__header-wrapper th {
  background-color: #f8f8f9;
  height: 40px;
  font-size: 14px;
  color: #6a7589;
}
.hovercont:hover {
  background: #f7f9fc;
}
.trandmarkimg {
  width: 45px;
  height: 45px;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>